import { render, staticRenderFns } from "./QuoteLimitSettingDia.vue?vue&type=template&id=52fd8e9c&scoped=true"
import script from "./QuoteLimitSettingDia.vue?vue&type=script&lang=js"
export * from "./QuoteLimitSettingDia.vue?vue&type=script&lang=js"
import style0 from "./QuoteLimitSettingDia.vue?vue&type=style&index=0&id=52fd8e9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fd8e9c",
  null
  
)

export default component.exports